import { Component, Input, ViewChild } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-rich-editor',
  templateUrl: './rich-editor.component.html',
  viewProviders: [
    DialogService,
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class RichEditorComponent {
  @Input() options: any;
  @Input() customId: any = 'myEditor';
  editorOptions = {};

  constructor(public dialogService: DialogService) {
    this.editorOptions = {
      height: 500,
      // content_css: [
      //   'https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css',
      //   // 'assets/style.css',
      // ],
      importcss_append: true,
      menubar: ['tools | edit | insert'],
      paste_data_images: true,
      image_title: true,
      automatic_uploads: true,
      plugins: [
        'advlist autolink lists link image charmap print preview anchor',
        'searchreplace visualblocks code fullscreen',
        'insertdatetime media table paste code help wordcount template importcss',
      ],
      toolbar1:
        'undo redo | code | media | formatselect | bold italic backcolor | \
  alignleft | aligncenter | alignright | alignjustify  \
  ',
      toolbar2:
        'bullist | numlist | outdent | indent | removeformat | help | customInsertButton customInsertButton2 insert template visualblocks',
      templates: [
        {
          title: 'Bootstrap',
          description: 'Bootstrap.',
          content: '<div class="row"><div>',
        },
        {
          title: 'New list with dates',
          description: 'New List with dates',
          content:
            '<div class="mceTmpl"><h1>Ovo je naslov</h1> <section class="row"><p class="col-4"></p></section> <p></p></div>',
        },
      ],
      setup: function (editor: any) {
        // editor.on('init', function (e: any) {
        //   editor.formatter.register('grid', {
        //     selector: 'div', // choose elements
        //     classes: 'grid',
        //     styles: {
        //       background: 'red',
        //       color: 'green',
        //     },
        //   }); // close formatter.register
        // }); // close editor.on init
        // editor.ui.registry.addButton('customInsertButton', {
        //   text: 'Insert image',
        //   onAction: function (_: any) {
        //     editor.insertContent(
        //       `<div class="container"><div class="row"></div></div>`
        //     );
        //   },
        // });
        // editor.ui.registry.addButton('customInsertButton2', {
        //   text: 'Insert image',
        //   onAction: function (_: any) {
        //     editor.insertContent(`<div class="col-4"></div>`);
        //   },
        // });
        // editor.ui.registry.addButton('customInsertButton', {
        //   text: 'Insert image',
        //   onAction: function (_: any) {
        //     console.log(editor);
        //     // editor.formatter.apply('flex');
        //     const ref = dialogService.open(MediaPopupDemoComponent, {
        //       header: 'Choose image',
        //       width: '70%',
        //     });
        //     ref.onClose.subscribe((image) => {
        //       editor.insertContent(`<img src="${image}" alt="" />`);
        //     });
        //     // navigator.clipboard
        //     //   .readText()
        //     //   .then((text) => {
        //     //     console.log('Pasted content: ', text);
        //     //     editor.insertContent(`<img src="${text}" alt="" />`);
        //     //   })
        //     //   .catch((err) => {
        //     //     console.error('Failed to read clipboard contents: ', err);
        //     //   });
        //   },
        // });
      },
    };
  }

  showMediaPopup() {
    // const ref = this.dialogService.open(MediaPopupDemoComponent, {
    //   header: 'Choose image',
    //   width: '70%',
    // });
  }
}
